module.exports = __webpack_public_path__ + "static/media/contact-mail.423bf41c.png";